import { css } from 'linaria';

export const headerSection = css`
  position: relative;
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const pageTitle = css`
  display: block;
  margin-bottom: 8px;

  @media (--only-mobile) {
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 26px;
  }
`;

export const headerSectionInfoContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 730px;

  @media (--only-desktop) {
    width: 535px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const headerSectionInfo = css`
  @media (--only-mobile) {
    order: 2;
  }
`;

export const headerSectionTitle = css`
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 8px;
    font-size: 28px;
    line-height: 34px;
  }
`;

export const headerSectionText = css`
  margin-bottom: 24px;

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const headerSectionImage = css`
  position: absolute;
  top: 34px;
  right: 0;
  width: 380px;
  height: 240px;
  border-radius: var(--rounding-m);

  @media (--only-desktop) {
    width: 373px;
    height: 236px;
  }

  @media (--only-tablet) {
    display: none;
  }

  @media (--only-mobile) {
    position: relative;
    top: 0;
    width: 100%;
    height: 100%;
    margin-bottom: 16px;
  }
`;

export const headerButton = css`
  && {
    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
